<template>
  <div class="check-list pl-0 md:pl-8 max-w-lg mx-auto md:mr-auto">
    <TypeDisplay
      :variant="$options.Typography.Display.GIGA"
      :weight="$options.Typography.Weights.STRONG"
      tag="h2"
      class="font-bold text-center mb-8"
      >{{ header }} Businesses</TypeDisplay
    >
    <div class="flex-col items-center sm:flex-row flex flex-wrap pl-8 md:pl-0">
      <div
        v-for="(item, index) in checklist"
        :key="`item-${index}`"
        class="block sm:flex sm:items-center max-w-none w-3/4 sm:max-w-1/2 sm:w-1/2 my-4"
      >
        <BaseIcon
          icon="check"
          class="alert-icon flex-shrink-0 text-secondary w-7 h-7 mr-4"
        />
        <TypeBody
          :variant="$options.Typography.Body.LARGE"
          :weight="$options.Typography.Weights.REGLAR"
          >{{ item }}</TypeBody
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { BaseIcon, TypeBody, TypeDisplay, constants } from '@bambeehr/pollen';
const { Typography } = constants;

export default defineComponent({
  name: 'BusinessCheckList',
  Typography,
  components: { BaseIcon, TypeBody, TypeDisplay },
  props: {
    header: {
      type: String,
      default: '',
    },
    checklist: {
      type: Array,
      default: () => [],
    },
  },
  setup() {},
});
</script>
